<style lang="less" scoped>
  .query-title-div {
    width: 110px !important;
  }
  .lang-width {
    width: 450px !important;
  }
  .margin-tb {
    height: 32px;
    margin-top: 4px;
  }
  .margin-tb-5{
    margin:5px 0;
  }
  .label-width{
    width: 60px;
  }
  .account_item{
  width: 237px;
  height: 101px;
  background: #4182EB;
  border-radius: 22px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-right: 50px;
  .img_con{
    width: 61px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 50%;
    line-height: 75px;
    text-align: center;
  }
  .amount_con{
    flex-grow: 1;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: right;

  }
  .amount_con :last-child{
    font-size: 26px;
    font-weight: 500;
  }
}
  .my-bg-button{
    padding: 0 10px;
    height: 30px;
    background: #4182EB ;
    border: 2px solid #4182EB;
    border-radius: 2px;
    outline: 0;
    line-height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 10px;
    cursor: pointer;
  }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">能量发放开关</div>
      <div class="flex margin-tb-10">
      <div class="account_item" style="background:#8F9BB3">
        <div class="img_con">
          <img src="../../../assets/detail/switch.png" alt="">
        </div>
           <div class="amount_con">
            <p>能量发放开关</p>
            <p style="font-size: 18px">当前状态：{{erengyObj.onOff == 'Y'? '开启':'关闭'}}</p>
          </div>
      </div>
      <div class="account_item">
        <div class="img_con">
          <img src="../../../assets/detail/eletricEnerge.png" alt="">
        </div>
           <div class="amount_con">
            <p>当前剩余能量值/g</p>
            <p>{{erengyObj.leftEnergyVal}}</p>
          </div>
      </div>
      <div class="account_item">
        <div class="img_con">
          <img src="../../../assets/detail/unconfirm.png" alt="">
        </div>
        <div class="amount_con">
          <p>当前待确认能量值/g</p>
          <p>{{erengyObj.unconfirmEnergyVal}}</p>
        </div>
      </div>
    </div>
      <div class="page-action-btns flex margin-tb-10">
        <div style="display: flex;flex-wrap:nowrap;min-width:280px">
          <button class="my-bg-button" @click="setDialog">能量发放设置</button>
          <button class="my-bg-button" @click="publish">手动发放</button>
          <button class="my-bg-button" @click="resultQuery">结果查询</button>
        </div>

        <div class="flex-grow-1 flex-r-end margin-right-16">
           <div class="flex-r-center margin-right-16">
            <p class="margin-right-10 font-14" style="min-width:80px">领取状态</p>
              <el-select
                v-model="queryInfo.claimStatus"
                size="small"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option label="待领取" value="toBeClaim"></el-option>
                <el-option label="已领取" value="claimed"></el-option>
                <el-option label="已过期" value="expired"></el-option>
              </el-select>
          </div>
          <div class="flex-r-center margin-right-16">
            <p class="margin-right-10 font-14" style="min-width:80px">获取状态</p>
              <el-select
                v-model="queryInfo.getStatus"
                size="small"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option label="待确认" value="01"></el-option>
                <el-option label="成功" value="02"></el-option>
                <el-option label="失败" value="03"></el-option>
              </el-select>
          </div>
          <div class="flex-r-center margin-right-16">
            <p class="margin-right-10 font-14 label-width" style="min-width:80px">关键字</p>
              <el-input
                v-model="queryInfo.keyWord"
                size="small"
                clearable
                placeholder="请输入订单编号/用户手机号"
              >
              </el-input>
          </div>
          <div class="flex-r-center">
            <p class="margin-right-10 font-14" style="min-width:80px">结束时间</p>
              <div class="flex-r">
                <el-date-picker
                  size="small"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  v-model="chargeTime"
                  @change="pickdate(chargeTime)"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
              </div>
          </div>
        </div>
        <div  style="display: flex;flex-wrap:nowrap;min-width:200px">
          <button class="my-bg-button" @click="getListData(pagination, true,isNormal)">搜 索</button>
          <button class="my-bg-button" @click="reset()">重 置</button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections=" (sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData(pagination, false,isNormal)"></ZD-pagination>
      </div>
    </div>
    <el-dialog title="能量开关设置" width="320px" :visible.sync="dialogShow">
      <div class="flex-r-center">
        <el-radio-group v-model="onOff">
          <el-radio label="Y">开启</el-radio>
          <el-radio label="N">关闭</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="flex-r-center">
          <el-button @click="cancelOnOffDialog" size="small">取 消</el-button>
          <el-button type="primary" @click="onOrOff()" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      mainTitle:'正常充电订单',
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      value1: true, //未使用
      chargeTime:[],
      mobile:'',
      isNormal:true,
      showMultiQuerys:false,
      erengyObj:{},
      typeList:[],
      onOff:'',
      dialogShow:false,
      operates: {
        width: 220,
        fixed: 'right',
        list: [
        ],
      }, // 列操作按钮
      searchTime: [], //系统创建时间
      timeOptionRange:'',
      pickerOptions: {
        onPick: time => {
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: time => {
          const timeOptionRange = this.timeOptionRange;
          const secondNum = 60 * 60 * 24 * 1 * 1000;
          if (timeOptionRange) {
            return (time.getTime() > timeOptionRange.getTime() + secondNum ||     time.getTime() <
            timeOptionRange.getTime() - secondNum);
          }
          return false;
        }
      }
    }
  },
  methods: {
      //查找站点名称 获取数据
    init() {
      this.mobile = this.$store.state.userInfo.userPhone
      this.getStats()
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.$H.post(_, _.$A.mayiEnerge.queryGeRecordPage, _.queryInfo).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        // console.log(_.tableData[0].chargeMin);
        _.$U.hideLoading(_)
      })
    },
    getStats(){
      let _ = this
      _.$H.post(_, _.$A.mayiEnerge.statsGreenEnergyRecharge, {}).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.erengyObj = res.data.data || []
      })
    },
    pickdate(time){
        console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTime = time ? time[0]: ''
      _.queryInfo.toTime = time ? time[1]: ''
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
          this.$U.error('请选择需要操作的对象');
          return false; 
      }
      if (selections.length > 1) {
          this.$U.error('只能选择一个操作的对象');
          return false;
      }
      return true;
    },
    //结果查询方法
    resultQuery() {
      let _ = this
      if(_.checkSelectOne(_.selections)){
        let obj = _.selections[0];
        if(obj.getStatus !== '03'){
          this.$U.error('仅失败状态的订单可才做结果查询');
          return
        }
        let params = {
          id : obj.id,
          mobile:obj.mobile,
          startDate:obj.chargeEndTime
        }
        _.$H.post(_, _.$A.mayiEnerge.query,params).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.erengyObj = res.data.data || []
        _.init()
      })
      }
    },
    //能量发放方法
    publish() {
      let _ = this
      if(_.checkSelectOne(_.selections)){
        let obj = _.selections[0];
        if(obj.getStatus !== '03'){
          this.$U.error('仅失败状态的订单才做手动发放!');
          return
        }
        let params = {
          id : obj.id,
          mobile:obj.mobile,
          chargeVal:obj.chargeVal
        }
      _.$U.showLoading(_)
        _.$H.post(_, _.$A.mayiEnerge.publish,params).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        let resData = res.data.data;
        if(resData.getStatus != '03'){
          this.$alert('发放成功！', '', {
            confirmButtonText: '我知道了',
            showClose:false,
            center: true,
            callback: action => {
              this.$message({
                type: 'primary',
                message: `action: ${ action }`
              });
            }
          });
        }else{
          this.$alert('发放失败,失败原因：'+resData.errorDesc, '', {
            confirmButtonText: '我知道了',
            showClose:false,
            center: true,
            callback: action => {}
          });
        }
        // this.$U.success('发放成功！');
        _.init()
        _.$U.hideLoading(_)
      })
      }
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0]
        this.queryInfo.dtTo = val[1]
      } else {
        delete this.queryInfo.dtFrom
        delete this.queryInfo.dtTo
      }
    },
        // 表单提交
    onOrOff() {
      let _ = this;
      if (_.$U.notEmpty(_.onOff)) {
        _.$U.showLoading(_);
        _.$H.post(_, _.$A.mayiEnerge.setOnOff, {onOff:_.onOff}).then(res => {
            if(res.status === 200){
              _.dialogShow = false
              _.init()
              _.$U.hideLoading(_);
              _.$U.success('更改成功！');
            }
          })
      }else{
        return _.$U.error('请选择能量开关！');
      }
    },
    setDialog(){
      this.onOff = this.erengyObj.onOff
      this.dialogShow = true
    },
    // 取消
    cancelOnOffDialog() {
      this.dialogShow = false
    },
    //重置
    reset() {
      this.queryInfo = {}
      this.chargeTime = []
      this.getListData(this.pagination,true)
    },
  },
  mounted() {
    this.init()
  },
}
</script>
